jQuery($ => {
    if ($('.o-featured-units')[0]) {
        $('.o-featured-units__show-all').click(function () {
            const $section = $(this).closest('section');
            const $5thItem = $section.find('.m-accordions__item:nth-child(5)');

            $section.removeClass('o-featured-units--hide-units');
            $5thItem.find('.m-accordion__toggle').focus();
        });

        $('.o-featured-units__expand-all').click(function () {
            const buttonText = $(this).find('.a-small-button__text')[0].innerText;
            const $buttonLine = $(this).find('line:first-child');
            const toExpand = buttonText.toLowerCase().includes('expand all');

            $buttonLine.toggle();

            $(this).find('.a-small-button__text')[0].innerText = toExpand ? 'Collapse All' : 'Expand All';

            const $accordions = $(this).closest('section').find('.m-accordion');

            $accordions.each(function () {
                if (toExpand) {
                    openAccordion($(this).find('*'));
                } else {
                    closeAccordion($(this).find('*'));
                }
            });
        });
    }

});